import SaleOfInformationModule from './SaleOfInformationModule';

export default SaleOfInformationModule;
